import { render, staticRenderFns } from "./TypeOfKnowledge.vue?vue&type=template&id=b5821cda&"
import script from "./TypeOfKnowledge.vue?vue&type=script&lang=js&"
export * from "./TypeOfKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports